<template>
	<div class="link-pago-page" style="position: relative;" v-if="espectaculo">
		<div class="cortesia-header">
			<div class="container">
				<div class="header-row">
					<div class="header-tipo">
						<span>{{ espectaculo.tipoNombre }}</span>
					</div>
				</div>
				<div class="header-row" v-if="espectaculo.requiereInstituciones">
					<div class="header-equipos">
						<div class="header-equipo header-equipo-local">
							<img :src="espectaculo.institucionLocalEscudo" :alt="espectaculo.institucionLocalNombre" class="header-escudo" />
							<span>{{ espectaculo.institucionLocalNombre }}</span>
							<span class="vs">vs</span>
						</div>
						<div class="header-equipo header-equipo-visitante">
							<img :src="espectaculo.institucionVisitanteEscudo" :alt="espectaculo.institucionVisitanteNombre" class="header-escudo" />
							<span>{{ espectaculo.institucionVisitanteNombre }}</span>
						</div>
					</div>
				</div>
				<div class="header-row" v-else>
					<div class="header-equipos">
						<div class="header-equipo header-equipo-local">
							<span>{{ espectaculo.nombre }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="cortesia-main" v-if="linkPago">
			<div class="container">
				<div class="cortesia-left">
					<h1>Comprar entradas</h1>
					<p>Completá los datos de tus entradas</p>
					<div class="cortesias" v-if="Number(linkPago.LinkPagoCntIngresadas) === 0">
						<div class="cortesia" :id="'tn' + t.ticketNum" v-for="t in tickets" :key="t.ticketNum" >
							<!-- <div class="cortesia-row">
								<span class="ticket-num">Ticket #{{ t.ticketNum }}</span>
							</div> -->
							<div class="cortesia-row">
								<div class="input-group">
									<label :for="'ticket-nombre-' + t.ticketNum">Nombres</label>
									<input type="text" name="ticket-nombre" :id="'ticket-nombre-' + t.ticketNum" v-model="t.ticketNombre">
								</div>
								<div class="input-group">
									<label :for="'ticket-apellido-' + t.ticketNum">Apellidos</label>
									<input type="text" name="ticket-apellido" :id="'ticket-apellido-' + t.ticketNum" v-model="t.ticketApellido">
								</div>
							</div>
							<div class="cortesia-row">
								<div class="input-group">
									<label :for="'ticket-tipoDocumento-' + t.ticketNum">Tipo de documento</label>
									<multiselect name="tipoDocumento" :id="'ticket-tipoDocumento-' + t.ticketNum" v-model="t.ticketDocumentoTipo" :options="tipoDocumentos" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="false">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontró tipo.</span>
										<span slot="noOptions">No hay tipos de documentos disponibles.</span>
									</multiselect>
								</div>
								<div class="input-group">
									<label :for="'ticket-documento-' + t.ticketNum">Documento</label>
									<input type="text" name="ticket-documento" :id="'ticket-documento-' + t.ticketNum" v-model="t.ticketDocumento" placeholder="Sin puntos ni guiones. Ej: 12345678">
								</div>
							</div>
							<!-- <div class="cortesia-row">
								<div class="input-group">
									<label :for="'ticket-telefono-' + t.ticketNum">Teléfono</label>
									<input type="text" name="ticket-telefono" :id="'ticket-telefono-' + t.ticketNum" v-model="t.ticketTelefono" @keypress="soloNumeros">
								</div>
								<div class="input-group">
									<span class="small-text">Por disposición del MSP, es obligatorio ingresar el número de teléfono del espectador</span>
								</div>
							</div> -->
							<div class="cortesia-row row-complemento">
								<div class="input-group" v-for="(complemento, index) in datosComplementarios" :key="complemento.ComplementoId">
									<label :for="complemento.ComplementoId">{{ complemento.ComplementoNombre }}</label>
									<input :name="complemento.ComplementoId" :id="complemento.ComplementoId" type="text" v-model="t.datosComplementarios[index].Valor" v-if="complemento.ComplementoTipo !== 'O'">
									<multiselect v-else :name="complemento.ComplementoId" :id="complemento.ComplementoId" v-model="t.datosComplementarios[index].Valor" :options="datosComplementarios[index].Opciones" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="true">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontraron resultados.</span>
										<span slot="noOptions">No se encontraron resultados.</span>
									</multiselect>
								</div>
							</div>
							<div class="cortesia-row">
								<div class="cortesia-ubicacion">
									<div class="cortesia-ubicacion-item">
										<span class="cortesia-ubicacion-title">Tribuna</span>
										<span class="cortesia-ubicacion-valor">{{ t.ticketTribuna }}</span>
									</div>
									<div class="cortesia-ubicacion-item" v-if="t.ticketSector.toUpperCase() !== 'ABDÓN PORTE'">
										<span class="cortesia-ubicacion-title">Sector</span>
										<span class="cortesia-ubicacion-valor">{{ t.ticketSector }}</span>
									</div>
									<div class="cortesia-ubicacion-item" v-if="t.ticketUbicacion !== null">
										<span class="cortesia-ubicacion-title">Fila</span>
										<span class="cortesia-ubicacion-valor">{{ t.ticketUbicacion.filaNombre }}</span>
									</div>
									<div class="cortesia-ubicacion-item" v-if="t.ticketUbicacion !== null">
										<span class="cortesia-ubicacion-title">Asiento</span>
										<span class="cortesia-ubicacion-valor">{{ t.ticketUbicacion.asientoNombre }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="cortesias-canjear" v-if="Number(linkPago.LinkPagoCntIngresadas) === 0">
						<button class="btn" @click="pagar" v-if="!pagando">Pagar {{ linkPago.LinkPagoMonedaSimbolo }}{{ linkPago.LinkPagoMontoTotal.replace('.00', '') }}</button>
						<button disabled="disabled" v-else>Pagando</button>
					</div>
					<div class="cortesias cortesias-emitidas" v-if="Number(linkPago.LinkPagoCntIngresadas) > 0">
						<span class="cortesias-emitidas-title">Tickets ya emitidos</span>
						<div class="cortesia" v-for="c in ticketsEmitidos" :key="c.TicketId">
							<div class="cortesia-row">
								<div class="input-group">
									<label>Nombres</label>
									<span>{{ c.PersonaNombre }}</span>
								</div>
								<div class="input-group">
									<label>Apellidos</label>
									<span>{{ c.PersonaApellido }}</span>
								</div>
								<a class="descargar-ticket" :href="c.TicketURLS3" target="_blank" v-if="c.TicketGeneradoEnS3">
									<download-icon></download-icon>Descargar
								</a>
								<div class="generando-ticket" v-else>
									<loader-icon></loader-icon>
									<span>Generando ticket. Recargue la página</span>
								</div>
							</div>
							<!-- <div class="cortesia-row">
								<div class="input-group">
									<label>Teléfono</label>
									<span>{{ c.PersonaTelefono }}</span>
								</div>
							</div> -->
							<div class="cortesia-row">
								<div class="input-group">
									<label>Tipo de documento</label>
									<span>{{ c.PersonaDocumentoTipoNombre }}</span>
								</div>
								<div class="input-group">
									<label>Documento</label>
									<span>{{ c.PersonaDocumento }}</span>
								</div>
							</div>
							<div class="cortesia-row">
								<div class="cortesia-ubicacion">
									<div class="cortesia-ubicacion-item">
										<span class="cortesia-ubicacion-title">Tribuna</span>
										<span class="cortesia-ubicacion-valor">{{ c.TribunaNombre }}</span>
									</div>
									<div class="cortesia-ubicacion-item" v-if="c.SectorDescripcion.toUpperCase() !== 'ABDÓN PORTE'">
										<span class="cortesia-ubicacion-title">Sector</span>
										<span class="cortesia-ubicacion-valor">{{ c.SectorDescripcion.replace('Sector ', '') }}</span>
									</div>
									<div class="cortesia-ubicacion-item" v-if="c.FilaId !== null && c.FilaId !== '0' && c.FilaId !== 0">
										<span class="cortesia-ubicacion-title">Fila</span>
										<span class="cortesia-ubicacion-valor">{{ c.FilaNombre.replace('Fila ', '') }}</span>
									</div>
									<div class="cortesia-ubicacion-item" v-if="c.AsientoId !== null && c.AsientoId !== '0' && c.AsientoId !== 0">
										<span class="cortesia-ubicacion-title">Asiento</span>
										<span class="cortesia-ubicacion-valor">{{ c.AsientoNombre.replace('Asiento ', '') }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="cortesia-right">
					<p>Información del espectáculo</p>
					<div class="cortesia-right-content">
						<div class="competencia" v-if="espectaculo.mostrarCompetencia">
							<div class="competencia-info">
								<span class="competencia-nombre">{{ espectaculo.competenciaNombre }}</span>
								<span class="competencia-instancia">{{ espectaculo.competenciaInstanciaNombre }}</span>
							</div>
							<img :src="espectaculo.competenciaLogo" :alt="espectaculo.competenciaNombre">
						</div>
						<div class="fecha" v-if="espectaculo.mostrarFecha">
							<span class="fecha-title">Fecha</span>
							<div class="fecha-content">
								<div class="fecha-texto">
									<p>{{ espectaculo.fechaDiaSemanaEscrito }}</p>
									<p>{{ espectaculo.fechaEscrita }}</p>
								</div>
								<div class="fecha-hora">
									{{ espectaculo.hora }}
								</div>
							</div>
						</div>
						<div class="lugar" v-if="espectaculo.mostrarEscenario">
							<span class="lugar-title">Lugar</span>
							<div class="lugar-content">
								<div class="lugar-content-left">
									<div class="lugar-info">
										<span class="lugar-escenario">{{ espectaculo.escenarioNombre }}</span>
										<span class="lugar-direccion">{{ espectaculo.escenarioDireccion }}</span>
									</div>
									<img :src="espectaculo.escenarioLogo" :alt="espectaculo.escenarioNombre">
								</div>
								<div class="ver-mapa" content="Ver ubicación" v-tippy="{ placement : 'bottom'}" v-if="espectaculo.escenarioMapaURL">
									<a :href="espectaculo.escenarioMapaURL" target="_blank"><map-icon></map-icon></a>
								</div>
							</div>
						</div>
						<div class="descripcion">
							<span class="descripcion-title">Descripción</span>
							<div class="espectaculo-descripcion" v-html="espectaculo.descripcion"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import { MapIcon, DownloadIcon, LoaderIcon } from 'vue-feather-icons'

	export default {
		data(){
			return {
				transaccionId: 0,
				transaccionFechaFin: null,
				linkPago: null,
				espectaculo: {
					id: null,
					nombre: '',
					descripcion: '',
					tipoId: null,
					tipoNombre: '',
					tipoColor: '',
					requiereCompetencia: true,
					requiereInstituciones: true,
					institucionLocalNombre: '',
					institucionLocalEscudo: '',
					institucionVisitanteNombre: '',
					institucionVisitanteEscudo: '',
					fecha: '',
					fechaEscrita: '',
					fechaDiaSemanaEscrito: '',
					hora: '',
					escenarioNombre: '',
					escenarioLogo: '',
					escenarioSVG: '',
					escenarioMapaURL: '',
					escenarioDireccion: '',
					competenciaNombre: '',
					competenciaInstanciaNombre: '',
					competenciaLogo: '',
					foto: null,
					requiereRepresentacionGrafica: true,
					mostrarCompetencia: false,
					mostrarFecha: false,
					mostrarEscenario: false,
					medioPagoId: null,
					medioPagoNombre: '',
					medioPagoIconoB64: '',
					medioPagoCuotas: null
				},
				pagando: false,
				hayError: false,
				errorMsg: '',
				tickets: [],
				ticketsEmitidos: [],
				tipoDocumentoCI: null,
				tipoDocumentos: [],
				filasAsientos: [],

				/* Mercadopago */
				preferenceId: null,
				initPoint: null,
				usuario: null,

				/* Datos complementarios */
				datosComplementarios: []
			}
		},
		components: {
			MapIcon,
			DownloadIcon,
			LoaderIcon
		},
		watch: {
			// ticketsEmitidos(newTicketsEmitidos){
			// 	this.ticketsEmitidos.forEach((t, index) => {
			// 		if(t.TicketGeneradoEnS3 === false){
			// 			this.timeoutCheckearTicket(t.TicketId, index);
			// 		}
			// 	});
			// },
			preferenceId: function(){
				const script = document.createElement('script');
				script.type = 'text/javascript';
				script.src = 'https://sdk.mercadopago.com/js/v2';
				script.addEventListener('load', ()=> {
					const mp = new MercadoPago(process.env.VUE_APP_MERCADOPAGO_PUBLIC_KEY, {
						locale: 'es-UY'
					});

					// Inicializa el checkout
					mp.checkout({
						preference: {
							id: this.preferenceId
						}
					});
				});
				document.body.appendChild(script);
			}
		},
		async mounted(){
			this.$store.dispatch('cargando', true);
			await this.tiposDocumento();
			await this.validarLinkPago();
			await this.obtenerTransaccion();
			this.$store.dispatch('cargando', false);
		},
		methods: {
			// timeout(){
			// 	return new Promise(resolve => setTimeout(resolve, 5000));
			// },
			// async timeoutCheckearTicket(ticketId, index){
			// 	do {
			// 		await this.timeout();
			// 		await this.checkearTicketGenerado(ticketId);
			// 	} while (this.ticketsEmitidos[index].TicketGeneradoEnS3 === false)
			// },
			// async checkearTicketGenerado(ticketId){
			// 	try {
			// 		let response = await axios.post('/WSTicketGeneradoEnS3', { TicketId: Number(ticketId) });
					
			// 		if(response.data.ErrorCod === 0){
			// 			if(response.data.isGeneradoEnS3 === true){
			// 				let indexEmitidos = this.ticketsEmitidos.map(ticket => ticket.TicketId).indexOf(ticketId)
			// 				this.ticketsEmitidos[indexEmitidos].TicketGeneradoEnS3 = true;
			// 			}
			// 		} else {
			// 			console.log('Ocurrió un error al checkear generación del PDF')
			// 		}
			// 	} catch (error) {
			// 		console.log('Ocurrió un error al checkear generacion del PDF')
			// 	}
			// },
			soloNumeros ($event) {
				let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
				if (keyCode < 48 || keyCode > 57) {
					$event.preventDefault();
				}
			},
			async tiposDocumento(){
				// Obtengo tipos de documento
				try{
					let response = await axios.post('/WSDocumentoTipoCortesiaPalco', {});
					for(var o=0; o<response.data.SDTDocumentoTipo.length; o++){
						this.tipoDocumentos.push({ valor: Number(response.data.SDTDocumentoTipo[o].DocumentoTipoId), descripcion: response.data.SDTDocumentoTipo[o].DocumentoTipoNombre });

						if(Number(response.data.SDTDocumentoTipo[o].DocumentoTipoId) === 1){
							this.tipoDocumentoCI = { valor: Number(response.data.SDTDocumentoTipo[o].DocumentoTipoId), descripcion: response.data.SDTDocumentoTipo[o].DocumentoTipoNombre }
						}
					}
				} catch (error){
					this.$router.push({ name: 'error' });
				}
			},
			async validarLinkPago(){
				// Valido link de pago
				try{
					let response = await axios.post('/WSLinkPagoValidar', {	
						EspectaculoId: Number(this.$route.params.espectaculoId), 
						LinkPagoId: Number(this.$route.params.linkPagoId), 
						LinkPagoToken: this.$route.params.linkPagoToken
					}, {});

					if(response.data.ErrorCod === 0){
						this.linkPago = response.data.SDTLinkPago;
						this.ticketsEmitidos = response.data.SDTTicketsCortesia;
						this.tickets = [];
						this.datosComplementarios = [];

						if(Number(this.linkPago.LinkPagoCntIngresadas) === 0){
							for(let i = 0; i<this.linkPago.LinkPagoCntSolicitadas; i++){
								let sector = this.linkPago.LinkPagoSectorDescripcion.replace('Sector ', '')
								
								let ticket = {
									ticketNum: i + 1,
									ticketNombre: '',
									ticketApellido: '',
									ticketDocumentoTipo: this.tipoDocumentoCI,
									ticketDocumento: '',
									ticketTelefono: '',
									ticketTribuna: this.linkPago.LinkPagoTribunaNombre,
									ticketSector: sector,
									ticketUbicacion: null,
									datosComplementarios: []
								}
								
								if(this.linkPago.Ubicacion.length > 0){
									for(let n=0; n<this.linkPago.Ubicacion.length; n++)	{
										if(n === i){
											let fila = this.linkPago.Ubicacion[n].LinkPagoFilaNombre.replace('Fila ', '')
											let asiento = this.linkPago.Ubicacion[n].LinkPagoAsientoNombre.replace('Asiento ', '')

											ticket.ticketUbicacion = { filaId: Number(this.linkPago.Ubicacion[n].LinkPagoFilaId), filaNombre: fila, asientoId: Number(this.linkPago.Ubicacion[n].LinkPagoAsientoId), asientoNombre: asiento }
											this.filasAsientos.push({
												fila: this.linkPago.Ubicacion[n].LinkPagoFilaId,
												asiento: this.linkPago.Ubicacion[n].LinkPagoAsientoId
											})
										}
									}
								}

								this.tickets.push(ticket);

								if(this.linkPago.Ubicacion.length === 0){
									this.filasAsientos.push({
										fila: '0',
										asiento: '0'
									})
								}
							}
						}

						let data = response.data.SDTEspectaculo;
						this.espectaculo.id = Number(data.EspectaculoId);
						this.espectaculo.nombre = data.EspectaculoNombre;
						this.espectaculo.descripcion = data.EspectaculoDescripcion;
						this.espectaculo.tipoId = Number(data.EspectaculoTipoId);
						this.espectaculo.tipoNombre = data.EspectaculoTipoNombre;
						this.espectaculo.tipoColor = data.EspectaculoTipoColor;
						this.espectaculo.requiereCompetencia = data.EspectaculoTipoRequiereCompetencia;
						this.espectaculo.requiereInstituciones = data.EspectaculoTipoRequiereInstitucion;
						this.espectaculo.institucionLocalNombre = data.InstitucionLocalNombre;
						this.espectaculo.institucionLocalEscudo = data.InstitucionLocalEscudoURL;
						this.espectaculo.institucionVisitanteNombre = data.InstitucionVisitanteNombre;
						this.espectaculo.institucionVisitanteEscudo = data.InstitucionVisitanteEscudoURL;
						this.espectaculo.fechaEscrita = data.EspectaculoFechaEscrita;
						this.espectaculo.fechaDiaSemanaEscrito = data.EspectaculoFechaDiaSemanaEscrito;
						this.espectaculo.hora = data.EspectaculoHora;
						this.espectaculo.escenarioNombre = data.EscenarioNombre;
						this.espectaculo.escenarioLogo = data.EscenarioLogoURL;
						this.espectaculo.escenarioMapaURL = data.EscenarioMapaURL;
						this.espectaculo.escenarioDireccion = data.EscenarioDireccion;
						this.espectaculo.competenciaNombre = data.CompetenciaNombre;
						this.espectaculo.competenciaInstanciaNombre = data.CompetenciaInstanciaNombre;
						this.espectaculo.competenciaLogo = data.CompetenciaImagenURL;
						this.espectaculo.requiereRepresentacionGrafica = data.EspectaculoRepresentacionGrafica;
						this.espectaculo.medioPagoId = data.MedioPagoId
						this.espectaculo.medioPagoNombre = data.MedioPagoNombre
						this.espectaculo.medioPagoIconoB64 = data.MedioPagoIconoB64
						this.espectaculo.medioPagoCuotas = data.MedioPagoCuotas

						if (data.EspectaculoFotoURL.length > 0) {
							this.espectaculo.foto = data.EspectaculoFotoURL;
						} else {
							this.espectaculo.foto = process.env.VUE_IMG_BUCKET + 'parque-aereo.jpg';
						}
						this.espectaculo.mostrarCompetencia = data.EspectaculoFrontMostrarCompetencia;
						this.espectaculo.mostrarFecha = data.EspectaculoFrontMostrarFecha;
						this.espectaculo.mostrarEscenario = data.EspectaculoFrontMostrarEscenario;

						await this.cargoDatosComplementarios();
					} else {
						this.$router.push({ name: 'error' });
					}
				} catch (error){
					this.$router.push({ name: 'error' });
				}
			},
			async obtenerTransaccion(){
				try{
					let response = await axios.post('/WSTransaccionLinkPago', {
						TransaccionMedio: 'W',
						TransaccionEspectaculoId: Number(this.$route.params.espectaculoId), 
						LinkPagoId: Number(this.$route.params.linkPagoId), 
						LinkPagoToken: this.$route.params.linkPagoToken,
						TransaccionEspectaculoTribunaId: Number(this.linkPago.LinkPagoTribunaId),
						TransaccionEspectaculoSectorCod: this.linkPago.LinkPagoSectorCod,
						TransaccionCantidad: Number(this.linkPago.LinkPagoCntSolicitadas),
						SDTFilaAsientoJSON: JSON.stringify(this.filasAsientos)
					}, {});

					if(response.data.ErrorCod === 0){
						this.transaccionId = Number(response.data.TransaccionId)
						this.transaccionFechaFin = response.data.TransaccionFechaFinTxt
					} else {
						this.$router.push({ name: 'error' });
					}
				} catch (error){
					this.$router.push({ name: 'error' });
				}
			},
			async cargoDatosComplementarios(){
				try {
					let response = await axios.post('/WSEspectaculoDatosComplCortesia', { EspectaculoId : Number(this.$route.params.espectaculoId) });
					
					if(response.data.ErrorCod === 0){
						response.data.SDTDatosComplementarios.map((d)=>{
							let opciones = [];
							let opcion = {}

							if(d.Opciones.length){
								for(let i = 0; i<d.Opciones.length; i++){
									opcion = {
										valor: d.Opciones[i].ComplementoOpcionId,
										descripcion: d.Opciones[i].ComplementoOpcionValor
									}

									opciones.push(opcion)
								}
							}
							
							let datoComplementario = {
								ComplementoId: d.ComplementoId,
								ComplementoNombre: d.ComplementoNombre,
								ComplementoTipo: d.ComplementoTipo,
								Opciones: opciones,
								EspectaculoComplementoObligatorio: d.EspectaculoComplementoObligatorio
							}

							this.datosComplementarios.push(datoComplementario);

							for(let j = 0; j<this.tickets.length; j++){
								this.tickets[j].datosComplementarios.push({ ComplementoId: d.ComplementoId, Valor: null });
							}
						});
					}
				} catch (error) {
					console.log('Error al cargar datos complementarios')
				}
			},
			async pagar(){
				this.pagando = true;
				this.$store.dispatch('cargando', true);

				await this.validacionDatos();

				if(parseFloat(this.linkPago.LinkPagoMontoTotal) > 0){
					if(this.hayError === false){
						if(Number(this.espectaculo.medioPagoId) === 2){
							// await this.crearOrdenDePagoPP();
						} else {
							await this.crearOrdenDePagoMP();
						}

						if(this.initPoint){
							let SDTPersona = []

							for(let m=0; m<this.tickets.length; m++){
								let SDTPersonaItem = {
									PersonaNombre: this.tickets[m].ticketNombre.trim(),
									PersonaApellido: this.tickets[m].ticketApellido.trim(),
									PersonaDocumentoTipoId: Number(this.tickets[m].ticketDocumentoTipo.valor),
									PersonaDocumento: this.tickets[m].ticketDocumento,
									PersonaSocioNro: '',
									PersonaButacaNro: '',
									PersonaSocioCategoriaid: 0,
									// PersonaTelefono: this.tickets[m].ticketTelefono
									PersonaTelefono: ''
								}
								SDTPersona.push(SDTPersonaItem);
							}

							// Emitir ticket
							let SDTTicket;
							let TicketItems = [];
							let TicketItem;
							let TicketComplemento;
							let SDTComplementosValores = [];
							let SDTComplementosValoresJSON = '';

							for(let n=0; n<this.tickets.length; n++){
								TicketItem = {
									Id: Number(n + 1),
									TicketMonto: parseFloat(this.linkPago.LinkPagoMontoTicket),
									TicketTipo: 'V',
									TribunaId: Number(this.linkPago.LinkPagoTribunaId),
									SectorCod: this.linkPago.LinkPagoSectorCod,
									FilaId: 0, // PROVISORIO, DE MOMENTO NO ACEPTAMOS NUMERADOS
									AsientoId: 0, // PROVISORIO, DE MOMENTO NO ACEPTAMOS NUMERADOS
									// FilaId: this.tickets[n].ticketUbicacion.filaId,
									// AsientoId: this.tickets[n].ticketUbicacion.asientoId,
									PersonaNombre: this.tickets[n].ticketNombre.trim(),
									PersonaApellido: this.tickets[n].ticketApellido.trim(),
									PersonaDocumentoTipoId: this.tickets[n].ticketDocumentoTipo.valor,
									PersonaDocumento: this.tickets[n].ticketDocumento,
									// PersonaTelefono: this.tickets[n].ticketTelefono,
									PersonaTelefono: '',
									PersonaSocioNro: '',
									PersonaButacaNro: '',
									PersonaSocioCategoriaid: 0,
									TicketButacaNro: '',
									TicketFilialId: 0,
									TicketPaisId: 0,
									TicketCiudadNombre: ''
								}
								TicketItems.push(TicketItem);

								for(let s=0; s<this.tickets[n].datosComplementarios.length; s++){
									let value = null;

									if(this.datosComplementarios[s].ComplementoTipo === 'O'){
										if(this.tickets[n].datosComplementarios[s].Valor){
											value = this.tickets[n].datosComplementarios[s].Valor.valor;
										}
									} else {
										if(this.tickets[n].datosComplementarios[s].Valor && this.tickets[n].datosComplementarios[s].Valor.trim() !== ''){
											value = this.tickets[n].datosComplementarios[s].Valor;
										}
									}

									if(value){
										TicketComplemento = {
											Index: Number(n + 1),
											ComplementoId: this.tickets[n].datosComplementarios[s].ComplementoId,
											ComplementoRegistroValor: value
										}

										SDTComplementosValores.push(TicketComplemento);
									}
								}
							}

							SDTComplementosValoresJSON = JSON.stringify(SDTComplementosValores);

							SDTTicket = { EspectaculoId: Number(this.$route.params.espectaculoId), TransaccionId: Number(this.transaccionId), Ticket: TicketItems}

							// Llamo a WSTicketPagoLinkPago
							try {
								let response = await axios.post('/WSTicketPagoLinkPago', {
									LinkPagoId: Number(this.linkPago.LinkPagoId),
									LinkPagoToken: this.linkPago.LinkPagoToken,
									SDTTicketJSON: JSON.stringify(SDTTicket),
									SDTPersonaJSON: JSON.stringify(SDTPersona),
									MonedaId: Number(this.linkPago.LinkPagoMonedaId),
									PagoMonto: parseFloat(this.linkPago.LinkPagoMontoTotal),
									SDTComplementosValoresJSON: SDTComplementosValoresJSON
								}, {});

								if(response.data.ErrorCod === 0){
									// Ticket emitido correctamente
									this.$store.dispatch('cargando', false);
									window.open(this.initPoint, '_self');
								} else {
									if(
										response.data.ErrorCod === 20
										|| response.data.ErrorCod === 21
										|| response.data.ErrorCod === 30
										|| response.data.ErrorCod === 40
										|| response.data.ErrorCod === 90
										|| response.data.ErrorCod === 91
										|| response.data.ErrorCod === 50
										|| response.data.ErrorCod === 60
										|| response.data.ErrorCod === 70
										|| response.data.ErrorCod === 80
										|| response.data.ErrorCod === 91
										|| response.data.ErrorCod === 90
										|| response.data.ErrorCod === 110
										|| response.data.ErrorCod === 112
										|| response.data.ErrorCod === 130
										|| response.data.ErrorCod === 131
										|| response.data.ErrorCod === 132
										|| response.data.ErrorCod === 133
										|| response.data.ErrorCod === 134
									){
										this.$store.dispatch('cargando', false);
										this.$store.dispatch('mostrarError', response.data.ErrorDsc)
										this.$router.push({ name: 'home' })
									} else {
										this.$store.dispatch('cargando', false);
										this.$store.dispatch('mostrarError', response.data.ErrorDsc)
									}
								}
							} catch (error) {
								this.$router.push({ name: 'error' });
							} finally {
								this.pagando = false
							}
						} else {
							this.pagando = false;
							this.$store.dispatch('mostrarError', 'Ocurrió un error. Intente más tarde.')
							this.$router.push({ name: 'home' })
						}
					} else {
						this.pagando = false;
						this.$store.dispatch('mostrarError', this.errorMsg)
						this.$store.dispatch('cargando', false);
					}
				} else {
					this.pagando = false;
					this.$store.dispatch('cargando', false);
				}
			},
			async validacionDatos(){
				this.hayError = false
				let documentoActual;

				for(var n=0; n<this.tickets.length; n++){
					documentoActual = this.tickets[n].ticketDocumento.trim()

					if(this.tickets[n].ticketNombre.trim().length <= 1){
						this.hayError = true
						this.errorMsg = 'Ingrese nombre de persona para el ticket ' + (n+1)
						break;
					}

					if(this.tickets[n].ticketApellido.trim().length <= 1){
						this.hayError = true
						this.errorMsg = 'Ingrese apellido de persona para el ticket ' + (n+1)
						break;
					}

					if(this.tickets[n].ticketDocumento.trim().length <= 1){
						this.hayError = true
						this.errorMsg = 'Ingrese documento de persona para el ticket ' + (n+1)
						break;
					}

					// if(!this.tickets[n].ticketTelefono){
					// 	this.hayError = true
					// 	this.errorMsg = 'Ingrese teléfono de persona para el ticket ' + (n+1)
					// 	break;
					// }

					// if(this.tickets[n].ticketTelefono.length < 8 || this.tickets[n].ticketTelefono.length > 20){
					// 	this.hayError = true
					// 	this.errorMsg = 'Ticket ' + (n+1) + ': teléfono incorrecto'
					// 	break;
					// }

					// Chequeo documentos repetidos
					for(var m=0; m<this.tickets.length; m++){
						if((m !== n) && documentoActual === this.tickets[m].ticketDocumento){
							this.hayError = true
							this.errorMsg = 'Hay documentos repetidos'
							break;
						}
					}

					// Validación datos complementarios
					for(let k=0; k<this.datosComplementarios.length; k++){
						let isDatoObligatorio = this.datosComplementarios[k].EspectaculoComplementoObligatorio;

						if(isDatoObligatorio){
							if(!this.tickets[n].datosComplementarios[k].Valor && this.datosComplementarios[k].ComplementoTipo === 'O'){
								this.hayError = true
								this.errorMsg = 'Ticket ' + (n+1) + ': debes seleccionar ' + this.datosComplementarios[k].ComplementoNombre.toLowerCase();
								break;
							}

							if(this.datosComplementarios[k].ComplementoTipo !== 'O'){
								if(!this.tickets[n].datosComplementarios[k].Valor){
									this.hayError = true
									this.errorMsg = 'Ticket ' + (n+1) + ': debes ingresar ' + this.datosComplementarios[k].ComplementoNombre.toLowerCase();
									break;
								} else {
									if(this.tickets[n].datosComplementarios[k].Valor.trim() === ''){
										this.hayError = true
										this.errorMsg = 'Ticket ' + (n+1) + ': debes ingresar ' + this.datosComplementarios[k].ComplementoNombre.toLowerCase();
										break;
									}
								}
							}
						}
					}
				}
			},
			async crearOrdenDePagoMP(){
				try {
					let tit = '';
					let dsc = '';

					if(Number(this.linkPago.LinkPagoCntSolicitadas) > 1){
						tit = "Entradas " + this.espectaculo.nombre.trim()
						dsc = String(this.linkPago.LinkPagoCntSolicitadas) + " entradas para " + this.espectaculo.nombre.trim() + ". Tribuna: " + this.linkPago.LinkPagoTribunaNombre.trim()
					} else {
						tit = "Entrada " + this.espectaculo.nombre.trim()
						dsc = "Entrada para " + this.espectaculo.nombre.trim() + ". Tribuna: " + this.linkPago.LinkPagoTribunaNombre.trim()
					}

					let trnFechaFinTimestamp = Date.parse(this.transaccionFechaFin)
					let trnFechaFin = new Date(trnFechaFinTimestamp)
					// let trnFechaFin = new Date(this.transaccionFechafin)
					trnFechaFin.setTime(trnFechaFin.getTime() - (60 *  1000)); // Le resto 60 segundos, para evitar problemas con fechas (demonio cancelación)
					let fchFin = trnFechaFin.getFullYear() + "-" + ('0' + (trnFechaFin.getMonth()+1)).slice(-2) + "-" + ('0' + trnFechaFin.getDate()).slice(-2) + "T" + String(trnFechaFin.getHours()).padStart(2, '0') + ":" + String(trnFechaFin.getMinutes()).padStart(2, '0') + ":" + String(trnFechaFin.getSeconds()).padStart(2, '0') + ".000-03:00"

					let preference = {
						binary_mode: true,
						items: [
							{
								id: String(this.espectaculo.id) + '-' + String(this.linkPago.LinkPagoTribunaId) + '-' + String(this.linkPago.LinkPagoSectorCod),
								title: tit,
								currency_id: this.linkPago.LinkPagoMonedaId,
								description: dsc,
								category_id: "tickets",
								quantity: 1,
								unit_price: parseFloat(this.linkPago.LinkPagoMontoTotal)
							}
						],
						payer: {
							name: this.linkPago.LinkPagoSolicitanteNombre,
							surname: '-',
							email: this.linkPago.LinkPagoSolicitanteEmail,
							identification: {
								// type: Number(this.usuario.UsuarioPersonaDocumentoTipoId),
								type: 1,
								number: ''
							}
						},
						back_urls: {
							success: this.$route.path,
							failure: ""
						},
						auto_return: "approved",
						payment_methods: {
							excluded_payment_types: [{ id: "ticket" }],
							installments: Number(this.espectaculo.medioPagoCuotas)
						},
						notification_url: process.env.VUE_APP_URL_NODE_MERCADOPAGO + "/ipn?source_news=ipn",
						external_reference: String(this.espectaculo.id) + "-" + String(this.transaccionId),
						expires: true,
						expiration_date_from: "",
						expiration_date_to: fchFin.trim(),
					};

					let response = await axios.post(process.env.VUE_APP_URL_NODE_MERCADOPAGO + '/create_preference', { preference: preference })

					this.preferenceId = response.data.preferenceId
					this.initPoint = response.data.initPoint
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.link-pago-page{
		min-height: var(--height-page);
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;
		@include flex(column, flex-start, center);

		.cortesia-header{
			padding-top: 76px;
			width: 100%;
			position: relative;
			height: 310px;
			background: url('../../assets/sports-player-background.jpg');
			background-position: center center;
			background-size: cover;
			background-repeat: no-repeat;
			@include flex(column, flex-start, center);

			.container{
				height: 100%;
				margin: 0;
				width: 100%;
				@include flex(column, flex-end, center);

				max-width: 1166px;
				padding: 0px 16px;
				z-index: 1;
				padding-bottom: 10px;
				@include flex(column, flex-end, flex-start);
			}

			.header-row{
				width: 100%;
				margin: 5px 0;
				@include flex(row, flex-start, center);

				.header-tipo{
					margin: 0;
					padding: 0;
					
					span{
						border-radius: 4px;
						background-color: var(--color-red);
						color: #fff;
						font-size: 11px;
						line-height: 1em;
						padding: 3px 7px;
						text-transform: uppercase;
						font-family: var(--font-family-poppins);
						letter-spacing: 0.5px;
					}
				}

				.header-equipos{
					margin: 5px 0 15px 0;
					padding: 0;
					position: relative;
					@include flex(column, center, flex-start);

					.header-equipo{
						@include flex(flex, flex-start, center);

						span{
							// font-family: 'Staatliches', cursive;
							line-height: 1.1em;
							color: var(--color-white);
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							text-transform: uppercase;
						}

						&.header-equipo-local{

							span{
								font-size: 32px;

								&.vs{
									font-family: var(--font-family-poppins);
									line-height: 1em;
									color: var(--color-blue-light);
									font-size: 24px;
									margin-left: 10px;
									margin-top: 6px;
									font-weight: var(--font-weight-bold);
								}
							}

							.header-escudo{
								height: 39px;
								width: auto;
								margin-right: 10px;
							}
						}

						&.header-equipo-visitante{
							margin-top: 5px;
							
							span{
								font-size: 30px;
							}

							.header-escudo{
								height: 34px;
								width: auto;
								margin-right: 10px;
								margin-left: 3px;
							}
						}
					}
				}
			}
		}

		.cortesia-main{
			width: 100%;
			position: relative;
			margin: 64px 0;
			@include flex(row, space-between, flex-start);
			
			.container{
				width: 100%;
				max-width: 1166px;
				padding: 0px 16px;
				@include flex(row, space-between, flex-start);

				.cortesia-right{
					top: 102px;
					position: sticky;
					margin-top: 41px;
					width: calc(33.33% - 16px);

					p{
						margin: 0;
						font-size: 18px;
						line-height: 26px;
						font-family: var(--font-family-fira);
						font-weight: bold;
						color: var(--color-dark);
						margin-bottom: 18px;
					}

					.cortesia-right-content{
						border-radius: 8px;
						border: 1px solid #d3d3dc;
						@include flex(column, flex-start, flex-start);

						.competencia{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(row, space-between, center);

							.competencia-info{
								@include flex(column, center, flex-start);

								span.competencia-nombre{
									margin: 0;
									font-size: 13px;
									line-height: 20px;
									margin-bottom: 0px;
									font-weight: var(--font-weight-bold);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									color: var(--color-dark);
									font-family: var(--font-family-poppins);
									text-transform: uppercase;
								}

								span.competencia-instancia{
									color: var(--color-dark);
									font-family: var(--font-family-fira);
									font-weight: var(--font-weight-regular);
									font-size: 15px;
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									line-height: 20px;
								}
							}

							img{
								height: 32px;
								width: auto;
								margin-left: 15px;
							}
						}

						.fecha{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(column, flex-start, flex-start);

							.fecha-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.fecha-content{
								width: 100%;
								@include flex(row, space-between, center);

								.fecha-texto{
									@include flex(column, center, flex-start);

									p{
										color: var(--color-dark);
										font-family: var(--font-family-fira);
										font-weight: var(--font-weight-regular);
										font-size: 15px;
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 20px;
										margin: 0;
									}
								}

								.fecha-hora{
									height: 100%;
									margin-left: 14px;
									border-left: 1px solid #d3d3dc;
									padding: 10px 0 10px 14px;
									color: var(--color-dark);
									font-family: var(--font-family-fira);
									font-weight: var(--font-weight-regular);
									font-size: 21px;
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									line-height: 20px;
								}
							}
						}

						.lugar{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(column, flex-start, flex-start);

							.lugar-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.lugar-content{
								@include flex(row, space-between, center);
								width: 100%;

								.lugar-content-left{
									@include flex(row, flex-start, center);

									.lugar-info{
										padding-right: 12px;
										// border-right: 1px solid #d3d3dc;
										@include flex(column, center, flex-start);

										span.lugar-escenario{
											color: var(--color-dark);
											font-family: var(--font-family-fira);
											font-weight: var(--font-weight-regular);
											font-size: 15px;
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 20px;
										}

										span.lugar-direccion{
											color: var(--color-dark);
											font-family: var(--font-family-fira);
											font-weight: var(--font-weight-regular);
											font-size: 13px;
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 18px;
										}
									}

									img{
										width: 28px;
										height: auto;
										margin-left: 12px;
									}
								}

								.ver-mapa{
									@include flex(column, center, center);
									margin-left: 12px;

									a{
										background-color: transparent;
										border: 1px solid var(--color-blue-darker);
										padding: 6px;
										text-decoration: none;
										@include flex(row, center, center);
										transition: all .2s;
										border-radius: 99px;

										svg{
											width: 15px;
											height: auto;
											transition: all .2s;
											color: var(--color-blue-darker);
										}

										&:hover{
											background-color: var(--color-blue-darker);

											svg{
												color: var(--color-white);
											}
										}
									}
								}
							}
						}

						.descripcion{
							border-radius: 0px;
							border: none;
							padding: 20px;
							width: 100%;
							@include flex(column, flex-start, flex-start);
							
							.descripcion-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.descripcion-content{
								color: var(--color-dark);
								font-family: var(--font-family-fira);
								font-weight: var(--font-weight-regular);
								font-size: 15px;
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								line-height: 20px;
							}
						}
					}
				}

				.cortesia-left{
					width: calc(66.66% - 16px);
					background-color: var(--color-white);
					padding: 0px;

					h1{
						margin: 0;
						margin-top: -5px;
						color: var(--color-red);
						font-weight: initial;
						font-size: 48px;
						line-height: 46px;
						font-family: var(--font-family-kapra-bold);
						text-transform: uppercase;
					}

					p{
						margin: 0;
						font-size: 18px;
						line-height: 26px;
						font-family: var(--font-family-fira);
						font-weight: bold;
						color: var(--color-dark);
					}

					.cortesias{
						width: 100%;
						margin-top: 20px;
						display: grid;
						grid-template-columns: repeat(1, 1fr);
						// grid-auto-rows: 1fr;
						// grid-column-gap: 20px;
						grid-row-gap: 25px;

						.cortesia{
							border-radius: 0px;
							box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);
							width: 100%;
							padding: 20px;
							padding-left: 70px;
							position: relative;
							background-color: var(--color-white);
							@include flex(column, flex-start, flex-start);
							transition: all .2s;

							&:hover{
								&:after{
									background-color: var(--color-blue-light);
									color: var(--color-blue-darker);
								}

								&:before{
									background-color: var(--color-blue-light);
									color: var(--color-blue-darker);
								}
							}

							&:after{
								content: 'Ticket';
								position: absolute;
								top: 0px;
								left: 0px;
								width: 50px;
								height: calc(100% - 50px);
								@include flex(row, center, center);
								color: var(--color-white);

								writing-mode:vertical-lr;

								font-family: var(--font-family-poppins);
								text-transform: uppercase;
								-webkit-letter-spacing: 2px;
								-moz-letter-spacing: 2px;
								-ms-letter-spacing: 2px;
								letter-spacing: 2px;
								font-size: 13px;
								background-color: var(--color-blue);
							}

							&:before{
								content: '';
								position: absolute;
								bottom: 0px;
								left: 0px;
								width: 50px;
								height: 50px;
								color: var(--color-white);
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								font-family: var(--font-family-poppins);
								@include flex(row, center, center);
								background-color: var(--color-red);
							}

							&#tn1:before{
								content: '#1';
							}

							&#tn2:before{
								content: '#2';
							}

							&#tn3:before{
								content: '#3';
							}

							&#tn4:before{
								content: '#4';
							}

							&#tn5:before{
								content: '#5';
							}

							&#tn6:before{
								content: '#6';
							}

							&#tn7:before{
								content: '#7';
							}

							&#tn8:before{
								content: '#8';
							}

							&#tn9:before{
								content: '#9';
							}

							&#tn10:before{
								content: '#10';
							}

							&#tn11:before{
								content: '#11';
							}

							&#tn12:before{
								content: '#12';
							}

							&#tn13:before{
								content: '#13';
							}

							&#tn14:before{
								content: '#14';
							}

							&#tn15:before{
								content: '#15';
							}

							&#tn16:before{
								content: '#16';
							}

							&#tn17:before{
								content: '#17';
							}

							&#tn18:before{
								content: '#18';
							}

							&#tn19:before{
								content: '#19';
							}

							&#tn20:before{
								content: '#20';
							}

							&#tn21:before{
								content: '#21';
							}

							&#tn22:before{
								content: '#22';
							}

							&#tn23:before{
								content: '#23';
							}

							&#tn24:before{
								content: '#24';
							}

							&#tn25:before{
								content: '#25';
							}

							&#tn26:before{
								content: '#26';
							}

							&#tn27:before{
								content: '#27';
							}

							&#tn28:before{
								content: '#28';
							}

							&#tn29:before{
								content: '#29';
							}

							&#tn30:before{
								content: '#30';
							}

							&#tn31:before{content: '#31' ;}
							&#tn32:before{content: '#32';}
							&#tn33:before{content: '#33';}
							&#tn34:before{content: '#34';}
							&#tn35:before{content: '#35';}
							&#tn36:before{content: '#36';}
							&#tn37:before{content: '#37';}
							&#tn38:before{content: '#38';}
							&#tn39:before{content: '#39';}
							&#tn40:before{content: '#40';}
							&#tn41:before{content: '#41';}
							&#tn42:before{content: '#42';}
							&#tn43:before{content: '#43';}
							&#tn44:before{content: '#44';}
							&#tn45:before{content: '#45';}
							&#tn46:before{content: '#46';}
							&#tn47:before{content: '#47';}
							&#tn48:before{content: '#48';}
							&#tn49:before{content: '#49';}
							&#tn50:before{content: '#50';}
							&#tn51:before{content: '#51';}
							&#tn52:before{content: '#52';}
							&#tn53:before{content: '#53';}
							&#tn54:before{content: '#54';}
							&#tn55:before{content: '#55';}
							&#tn56:before{content: '#56';}
							&#tn57:before{content: '#57';}
							&#tn58:before{content: '#58';}
							&#tn59:before{content: '#59';}
							&#tn60:before{content: '#60';}
							&#tn61:before{content: '#61';}
							&#tn62:before{content: '#62';}
							&#tn63:before{content: '#63';}
							&#tn64:before{content: '#64';}
							&#tn65:before{content: '#65';}
							&#tn66:before{content: '#66';}
							&#tn67:before{content: '#67';}
							&#tn68:before{content: '#68';}
							&#tn69:before{content: '#69';}
							&#tn70:before{content: '#70';}
							&#tn71:before{content: '#71';}
							&#tn72:before{content: '#72';}
							&#tn73:before{content: '#73';}
							&#tn74:before{content: '#74';}
							&#tn75:before{content: '#75';}
							&#tn76:before{content: '#76';}
							&#tn77:before{content: '#77';}
							&#tn78:before{content: '#78';}
							&#tn79:before{content: '#79';}
							&#tn80:before{content: '#80';}
							&#tn81:before{content: '#81';}
							&#tn82:before{content: '#82';}
							&#tn83:before{content: '#83';}
							&#tn84:before{content: '#84';}
							&#tn85:before{content: '#85';}
							&#tn86:before{content: '#86';}
							&#tn87:before{content: '#87';}
							&#tn88:before{content: '#88';}
							&#tn89:before{content: '#89';}
							&#tn90:before{content: '#90';}
							&#tn91:before{content: '#91';}
							&#tn92:before{content: '#92';}
							&#tn93:before{content: '#93';}
							&#tn94:before{content: '#94';}
							&#tn95:before{content: '#95';}
							&#tn96:before{content: '#96';}
							&#tn97:before{content: '#97';}
							&#tn98:before{content: '#98';}
							&#tn99:before{content: '#99';}
							&#tn100:before{content: '#100';}

							.cortesia-row{
								width: 100%;
								@include flex(row, space-between, center);

								.input-group{
									width: 50%;
									padding: 0px 8px 8px 8px;
									margin: 0;
									@include flex(column, center, flex-start);
									position: relative;

									&:first-child{
										padding-left: 0px;
									}

									&:last-child{
										padding-right: 0px;
									}

									label{
										font-size: 16px;
										font-weight: var(--font-weight-regular);
										color: var(--color-grey);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 19px;
										font-family: var(--font-family-fira);
									}

									input{
										font-size: 16px;
										line-height: 25px;
										padding-top: 8px;
										border-bottom: 1px solid var(--color-grey-light);
										display: block;
										width: 100%;
										font-weight: var(--font-weight-bold);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
										padding-top: 8px;
										padding-bottom: 10px;

										&:focus{
											border-color: var(--color-blue);
										}
									}

									.small-text{
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-grey);
										font-family: var(--font-family-fira);
										font-size: 11px;
										line-height: 1.4em;
										padding: 0px 10px;
									}
								}

								.cortesia-ubicacion{
									margin-top: 10px;
									width: 100%;
									@include flex(row, flex-start, center);

									.cortesia-ubicacion-item{
										padding: 8px 22px 8px 12px;
										// border: 1px dashed var(--color-grey-medium);
										// background-color: #f3f3f9;
										border-right: 1px dashed var(--color-grey-medium);
										border-radius: 0px;
										@include flex(column, flex-start, flex-start);
										margin-right: 10px;

										&:last-child{
											border-right: none;
										}

										.cortesia-ubicacion-title{
											font-size: 14px;
											font-weight: var(--font-weight-regular);
											color: var(--color-grey);
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 16px;
											font-family: var(--font-family-fira);
										}

										.cortesia-ubicacion-valor{
											font-weight: var(--font-weight-bold);
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											color: var(--color-dark);
											font-family: var(--font-family-poppins);
											text-transform: uppercase;
										}
									}
								}

								&.row-complemento{
									flex-wrap: wrap;

									.input-group{
										width: 50%;
										padding-bottom: 15px;

										&:nth-child(2n){
											padding-right: 0px;
										}

										&:nth-child(2n + 1){
											padding-left: 0px;
										}
									}
								}
							}

							.ticket-num{
								font-weight: var(--font-weight-bold);
								font-family: var(--font-family-poppins);
								font-size: 12px;
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								padding: 2px 9px;
								border-radius: 22px;
								background-color: transparent;
								border: 1px solid var(--color-blue);
								color: var(--color-blue);
								letter-spacing: 1px;
								transition: all .2s;
							}
						}
					}

					.cortesias-canjear{
						position: sticky;
						bottom: 0px;
						
						button.btn{
							width: 100%;
							@include flex(row, center, center);
							text-transform: uppercase;
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							position: relative;
							cursor: pointer;
							width: 100%;
							background-color: var(--color-red);
							color: var(--color-white);
							-webkit-transition: background-color .2s ease;
							transition: background-color .2s ease;
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							min-height: 48px;
							padding: 0 24px;
							font-size: 16px;
							line-height: 25px;
							-webkit-font-smoothing: antialiased;
							-moz-osx-font-smoothing: grayscale;
							outline-color: transparent;
							outline: none;
							box-shadow: none;
							border: 0;
							margin: 0;
							margin-top: 32px;

							&:hover{
								background-color: var(--color-blue-dark);
							}
						}
					}

					.cortesias-emitidas{
						margin-top: 30px;

						.cortesias-emitidas-title{
							margin: 0;
							font-size: 18px;
							line-height: 26px;
							font-family: var(--font-family-fira);
							font-weight: bold;
							color: var(--color-dark);
						}

						.cortesia{
							&:after{
								background-color: var(--color-grey-light);
								color: var(--color-blue-darker);
								height: 100%;
							}

							&:before{
								content: none;
							}

							&:hover{
								&:after{
									background-color: var(--color-grey-light);
									color: var(--color-blue-darker);
								}
							}

							.cortesia-row{
								@include flex(row, flex-start, center);

								.input-group{
									width: 40%;

									span{
										margin: 0;
										font-size: 16px;
										line-height: 25px;
										font-weight: var(--font-weight-bold);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
										padding-left: 0;
										padding-top: 4px;
										padding-bottom: 5px;
									}
								}

								.descargar-ticket{
									width: 20%;
									@include flex(column, center, center);
									color: var(--color-blue);
									font-size: 13px;
									cursor: pointer;
									line-height: 25px;
									font-weight: var(--font-weight-bold);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									font-family: var(--font-family-poppins);
									text-transform: uppercase;
									text-decoration: none;
									transition: all .2s;

									svg{
										height: auto;
										width: 18px;
										margin-bottom: 4px;
									}

									&:hover{
										opacity: 0.8;
									}
								}

								.generando-ticket{
									width: 20%;
									@include flex(column, center, center);
									color: var(--color-grey);
									font-size: 12px;
									line-height: 18px;
									font-weight: var(--font-weight-regular);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									font-family: var(--font-family-fira);
									text-decoration: none;
									text-align: center;
									transition: all .2s;

									svg{
										height: auto;
										width: 24px;
										margin-bottom: 6px;
										-webkit-animation: rotating 2s linear infinite;
										-moz-animation: rotating 2s linear infinite;
										-ms-animation: rotating 2s linear infinite;
										-o-animation: rotating 2s linear infinite;
										animation: rotating 2s linear infinite;
									}
								}

								.cortesia-ubicacion{
									padding-top: 10px;
									border-top: 1px solid var(--color-grey-light);
									width: 100%;
								}
							}
						}
					}
				}
			}
		}
	}

	/* Responsive */
	@media screen and(max-width: 910px){
		.link-pago-page{
			.cortesia-header{
				.container{
					.header-row{
						&:last-child{
							margin: 0px;
						}

						.header-tipo{
							span{
								font-size: 10px;
								padding: 2px 6px;
								border-radius: 3px;
							}
						}

						.header-equipos .header-equipo.header-equipo-local span{
							font-size: 24px;
						}

						.header-equipos .header-equipo.header-equipo-local .header-escudo{
							height: 32px;
						}

						.header-equipos .header-equipo.header-equipo-local span.vs{
							font-size: 18px;
							margin-left: 8px;
							margin-top: 3px;
						}

						.header-equipos .header-equipo.header-equipo-visitante .header-escudo{
							height: 28px;
						}

						.header-equipos .header-equipo.header-equipo-visitante span{
							font-size: 20px;
						}
					}
				}
			}

			.cortesia-main{
				margin: 30px 0;
				.container{
					@include flex(column, flex-start, flex-start);

					.cortesia-left{
						width: 100%;
					}

					.cortesia-right{
						margin-top: 30px;
						position: relative;
						top: auto;
						width: 100%;
					}
				}
			}
		}
	}

	@media screen and(max-width: 590px){
		.link-pago-page{
			.cortesia-main{
				.container{
					 .cortesia-left{
						  .cortesias{
							   .cortesia{
								   padding-left: 60px;

								    .cortesia-row{
										.input-group{
											label{
												font-size: 14px;
												line-height: 17px;
											}

											input{
												font-size: 14px;
												line-height: 20px;
											}

											.small-text{
												display: none;
											}
										}

										.cortesia-ubicacion{
											.cortesia-ubicacion-item{
												padding: 4px 10px 4px 0px;

												.cortesia-ubicacion-title{
													font-size: 13px;
													line-height: 15px;
												}

												.cortesia-ubicacion-valor{
													font-size: 14px;
													line-height: 1.4em;
												}
											}
										}

										&.row-complemento{
											.input-group{
												width: 100%;
											}
										}
									}

									&:after{
										width: 40px;
										height: calc(100% - 40px);
									}

									&:before{
										width: 40px;
										height: 40px;
										font-size: 13px;
									}
							   }
						  }
						  .cortesias-canjear button.btn{
							  min-height: 40px;
							  margin-top: 20px;
							  font-size: 14px;
						  }
						  .cortesias-emitidas{
							.cortesia{
								&:after{
									background-color: var(--color-grey-light);
									color: var(--color-blue-darker);
									height: 100%;
								}

								&:before{
									content: none;
								}

								&:hover{
									&:after{
										background-color: var(--color-grey-light);
										color: var(--color-blue-darker);
									}
								}

								 .cortesia-row{
									.input-group{
										width: 80%;
										label{
											font-size: 13px;
											line-height: 16px;
										}

										span{
											font-size: 13px;
											line-height: 18px;
										}
									}

									.descargar-ticket, .generando-ticket{
										position: absolute;
										top: 20px;
										right: 20px;
										font-size: 11px;
									}

									.cortesia-ubicacion{
										.cortesia-ubicacion-item{
											padding: 3px 10px 3px 0px;

											.cortesia-ubicacion-title{
												font-size: 12px;
												line-height: 14px;
											}

											.cortesia-ubicacion-valor{
												font-size: 13px;
												line-height: 1.3em;
											}
										}
									}
								 }
							}
						  }
					 }
				}
			}
		}
	}

	@media screen and(max-width: 510px){
		.link-pago-page{
			.cortesia-main{
				.container{
					 .cortesia-left{
						  .cortesias{
							   .cortesia{
								    .cortesia-row{
										@include flex(column, flex-start, flex-start);

										.input-group{
											width: 100%;
											padding: 0px;
											padding-bottom: 5px;
										}

										.cortesia-ubicacion{
											flex-wrap: wrap;
										}
									}
							   }
						  }
					 }
				}
			}
		}
	}

	@media screen and(max-width: 490px){
		.link-pago-page{
			.cortesia-header{
				height: 250px;

				.container{
					.header-row{
						&:last-child{
							margin: 0px;
						}

						.header-tipo{
							span{
								font-size: 10px;
								padding: 2px 6px;
								border-radius: 3px;
							}
						}

						.header-equipos .header-equipo.header-equipo-local span{
							font-size: 20px;
						}

						.header-equipos .header-equipo.header-equipo-local .header-escudo{
							height: 30px;
						}

						.header-equipos .header-equipo.header-equipo-local span.vs{
							display: none;
						}

						.header-equipos .header-equipo.header-equipo-visitante .header-escudo{
							height: 26px;
						}

						.header-equipos .header-equipo.header-equipo-visitante span{
							font-size: 20px;
						}
					}
				}
			}
		}
	}

	@-webkit-keyframes rotating {
		from {
			-webkit-transform: rotate(0deg);
			-o-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		to {
			-webkit-transform: rotate(360deg);
			-o-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
	@keyframes rotating {
		from {
			-ms-transform: rotate(0deg);
			-moz-transform: rotate(0deg);
			-webkit-transform: rotate(0deg);
			-o-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		to {
			-ms-transform: rotate(360deg);
			-moz-transform: rotate(360deg);
			-webkit-transform: rotate(360deg);
			-o-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
</style>